import React, { Component } from 'react';

import Modal from 'components/Modal';
import { ApSearchDropdown } from '@alixpartners/ui-components';

import { TaxonomyForm } from './styles';

export class CellModalEditor extends Component {
	state = {
		value: this.props.value,
		isFormValid: false,
	};

	handleChange = value => {
		this.setState({ value, isFormValid: true });
	};

	handleSubmit = () => {
		const { onClose, onSave, editingRowNode } = this.props;
		const { value } = this.state;

		onSave({ value, editingRowNode });
		onClose();
	};

	render() {
		const { options, onClose, allowNewOption } = this.props;
		const { value, isFormValid } = this.state;

		return (
			<Modal
				title="Edit Vendor Name"
				cancelLabel="Cancel"
				submitLabel="Save"
				onSubmit={isFormValid ? this.handleSubmit : null}
				onClose={onClose}
			>
				<TaxonomyForm>
					<ApSearchDropdown
						options={options}
						value={value}
						placeholder="Enter vendor name"
						onInputChange={this.handleChange}
						onSuggestionSelected={this.handleChange}
						allowNewOption={allowNewOption}
					/>
				</TaxonomyForm>
			</Modal>
		);
	}
}
